import { axiosApi } from "../../../../../api/dbAxios";

export const fetchUserSettings = async () => {
  try {
    const response = await axiosApi.get(`/settings/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user settings:", error);
    return [];
  }
};
